import { translateTo } from './translateTo';

/**
 * Devuelve la cadena traducida y interpolada si tiene variables.
 *
 * # Cada `key` puede ser un {string} o un {Object}:
 * --------------------------------------------------
 * `keys` es un `key` o una colección de `key`,
 * y cada uno individualmente puede ser
 * - un {string}
 * @example 'global.foo'
 *
 * - un {Object<string, object>}
 * @example {'global.foo': { foo: 'bar' } }
 *
 * # `keys` puede ser un string o un array:
 * -----------------------------------------
 * - Si `keys` es un string, devolvera un string:
 * @example edicom.locale.translate('global.foo') // -> 'bar'
 *
 * - Si `keys` es un array, devolvera un objeto:
 * @example
 * edicom.locale.translate([
 *   'global.foo', // -> 'bar'
 *   { 'global.min': {min: 3} }, // -> 'Minimo 3'
 * ]) // -> { 'global.foo': 'bar', 'global.min': 'Minimo 3' }
 *
 *
 * @param {Object} state
 * @param {string|string[]|Object[]} keys la clave de la cadena, o un array de claves
 * @param {Object} [params] el objeto con los valores de las variables a interpolar
 * @param {string} [defaultValue] el valor por defecto si "Error not found" sino especificado, devuelve el `key` buscado
 * @returns {string|object<key: value>}
 */
export function translate(state, keys, params, defaultValue) {
  return translateTo(state, state.id, keys, params, defaultValue);
}
